import React from 'react';

import Show from 'components/Show';
import Avatar from 'components/Misc/Avatar';
import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import { useUserProfileStore } from 'store/user/useUserProfileStore';
import { useTeacherCourseStore } from 'store/user/useTeacherCourseStore';

const Course = ({ isSelected, course }) => {
	// Use user's profile store
	const id = useUserProfileStore(state => state.user.id);

	// Use user's creation store
	const [onAddCourse, onRemoveCourse] = useTeacherCourseStore(state => [
		state.onAdd,
		state.onRemove
	]);

	// Handle course addition for teacher
	const onAdd = () => onAddCourse(course);

	// Handle course removal for teacher
	const onRemove = () => onRemoveCourse(course.id);

	return (
		<div className="py-3 px-4 border rounded-lg space-y-2 dark:border-neutral-700 transition-colors">
			{/* Course's information and control */}
			<div className="flex items-center space-x-2">
				<Title
					title={course.title}
					subtitle={course.subject?.title}
					className="flex-1"
				/>

				<Button
					small
					square
					icon="link"
					to={`/courses/${course.id}`}
				/>

				{/* Course removal if is in selected list */}
				<Show if={isSelected}>
					<Button
						small
						square
						icon="close"
						theme="danger"
						onClick={onRemove}
					/>
				</Show>

				{/* Course addition if is in modal list */}
				<Show if={!isSelected}>
					<Button
						small
						square
						icon="add"
						theme="success"
						onClick={onAdd}
					/>
				</Show>
			</div>

			{/* Currently active course's teacher */}
			<Show if={course.teacher?.id && course.teacher.id !== id}>
				<div className="flex items-center space-x-2">
					<Avatar
						alt={course.teacher?.fullName}
						src={course.teacher?.avatar}
						className="w-8 h-8 leading-8"
					/>

					<Title
						title={course.teacher?.fullName}
						subtitle={course.teacher?.status}
						className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
					/>

					<Button
						small
						square
						icon="link"
						to={`/users/${course.teacher?.id}`}
					/>
				</div>
			</Show>

			{/* Show warning if course has a teacher */}
			<Show if={isSelected && course.teacher?.id && course.teacher.id !== id}>
				<div className="py-2 px-3 flex bg-red-500 text-white rounded-lg">
					Esošais pedagogs tiks noņemts no dotā moduļa!
				</div>
			</Show>
		</div>
	);
};

export default Course;